export const errorMessages = {
  required: (fieldName: string) => `${fieldName} is required`,
  invalidEmail: "Invalid email address",
  invalidFax: "Invalid fax number",
  characterLimit: (fieldName: string, limit: number) =>
    `${fieldName} should not exceed ${limit} characters`,
  minCharacterLimit: (fieldName: string, limit: number) =>
    `${fieldName} must contain a minimum of ${limit} characters`,
  alphabetsAndSpaceValidation(fieldName: string) {
    return `${fieldName} must only contain alphabets and white spaces`;
  },
  length(fieldName: string, limit: number) {
    return `${fieldName} must contain ${limit} characters`;
  },
  previousPasswords() {
    return `Previous ${process.env.REACT_APP_PASSWORD_HISTORY_LIMIT} passwords cannot be reused.`;
  },
  npiLengthError: "NPI must have 10 digits",
  npiRegexMisMatch:
    "Invalid input. Please enter comma separated 10 digit numbers.",
  activeSessionExists:
    "An active session exists already, please try again later.",
  passwordRegexMatch:
    "Password must contain at least one uppercase letter, one lowercase letter, one special character and one number.",
  confirmPassword: "Passwords must match",
  passwordMismatch: "New password cannot be same as current password",
  renterPassword: "Re-enter your new password",
  passwordUpdateFailed: "Password changes failed. Please try again.",
  validEmail: "Enter valid email address",
  errorInfo: "An error occurred.Try Again later!!",
  faxValidation: "Fax number should be minimum of 6 characters",
  invalidFaxNumber:
    "Only numbers, space, comma, +, -, #, *, (, and ) are allowed",
  invalidVerificationCode: "Invalid/Expired code",
  invalidGuidFormat:
    "Enter a valid HALO Link GUID in the format XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
  invalid_BPSiteID_or_PairingCode: "Invalid BP Site ID or Pairing code",
  invalid_BpSiteID: "Invalid BP Site ID",
  invalid_PairingCode: "Invalid pairing code",
  cannot_connect_to_BP:
    "We cannot connect to your BP system. Please contact our support team at support@incahealth.com.au",
  cannot_verify_BP_Site_ID:
    "Unable to verify the BP Site ID. Please ensure that your BP Premier is configured to allow third party integrations.",
  invalid_PairingCode_Format:
    "Enter a valid pairing code in the format XXXX-XXXX-XXXX.",
  downloadSessionExpired:
    "Your session has expired. Please refresh the page and try again.",
  downloadInvalidResponse:
    "Your session may have expired. Please refresh the page and try again.",
};
